import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Crest } from "src/app/classes/crest";
import { CrestService } from "src/app/services/crest.service";


@Component({
  selector: 'app-sponsor-single',
  templateUrl: './sponsor-single.component.html',
  styleUrls: ['./sponsor-single.component.scss']
})
export class SponsorSingleComponent implements OnInit {
    
    busy: Subscription;
    pathList: string[][];
    id: number
    single: Crest;
    SponsorPart = "Nuovo Sponsor"
    constructor (private ar: ActivatedRoute, private router: Router, public CrestService: CrestService) {
      this.pathList = [['sponsor', 'sponsor/list']];
    }
    loga($event) {
      this.pathList.push($event);
      console.log($event)
    }

    ngOnInit(): void {
          this.id = parseInt(this.ar.snapshot.paramMap.get('id'), 10);
          this.single = new Crest();
          
    }
}